export function expandDateSearchVariants(search: string): string[] {
  const trimmed = search.trim()
  const variants = new Set<string>([search])
  if(!trimmed) {
    return Array.from(variants)
  }
  const pad = (s: string) => s.padStart(2, '0')
  const isValidMonth = (s: string) => {
    const n = Number(s)
    return n >= 1 && n <= 12
  }
  const isValidDay = (s: string) => {
    const n = Number(s)
    return n >= 1 && n <= 31
  }

  const fullMatch = trimmed.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/)
  if(fullMatch) {
    const [, p1, p2, year] = fullMatch
    if(isValidDay(p1) && isValidMonth(p2)) {
      variants.add(`${year}-${pad(p2)}-${pad(p1)}`)
    }
    if(isValidMonth(p1) && isValidDay(p2)) {
      variants.add(`${year}-${pad(p1)}-${pad(p2)}`)
    }
    return Array.from(variants)
  }

  const partialMatch = trimmed.match(/^(\d{1,2})-(\d{1,2})$/)
  if(partialMatch) {
    const [, p1, p2] = partialMatch
    if(isValidDay(p1) && isValidMonth(p2)) {
      variants.add(`-${pad(p2)}-${pad(p1)}`)
    }
    if(isValidMonth(p1) && isValidDay(p2)) {
      variants.add(`-${pad(p1)}-${pad(p2)}`)
    }
  }

  return Array.from(variants)
}
